module.exports = __webpack_public_path__ + "img/c3.0ddf5b30.jpg";